import { Injectable } from "@angular/core";
import { Config } from "./config.const";

@Injectable()
export class EmailService {
    async get() {
        const request = await fetch(`${Config.baseURL}/email`, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await request.json()
    }
}



// WEBPACK FOOTER //
// ./src/app/email.service.ts